/* begin general import */

import { Add16, Time16 } from "@carbon/icons-react";
import Close16 from "@carbon/icons-react/es/close/16";
import Send16 from "@carbon/icons-react/es/send/16";
import { Col, Row, Spin, Switch } from "antd";
import { API_ROLE_PREFIX } from "config/api-consts";
import { ROLE_DETAIL_ROUTE, ROLE_ROUTE } from "config/route-consts";
import { Role } from "models/Role";
import { SiteFilter } from "models/Site";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  FormItem,
  InputText,
  MultipleSelect,
  Select,
  StandardTable,
  Tabs,
  TagFilter,
} from "react3l-ui-library";
import { roleRepository } from "repositories/role-repository";
import appMessageService from "services/common-services/app-message-service";
import { authorizationService } from "services/common-services/authorization-service";
import { utilService } from "services/common-services/util-service";
import {
  ModelActionEnum,
  detailService,
} from "services/page-services/detail-service";
import { fieldService } from "services/page-services/field-service";
import nameof from "ts-nameof.macro";
import PermissionRoleTreeView from "./PermissionRoleTreeView/PermissionRoleTreeView";
import "./RoleDetail.scss";
import AppUserRoleAdvanceFilter from "./RoleDetailHook/AppUserRoleAdvanceFilter";
import {
  AppUserRoleMappingModal,
  useAppUserRoleMappingModalHook,
  useAppUserRoleMappingTable,
} from "./RoleDetailHook/AppUserRoleMappingHook";
import { webService } from "services/common-services/web-service";
import { masterService } from "services/page-services/master-service";

function RoleDetail() {
  const [translate] = useTranslation();

  const { validAction } = authorizationService.useAuthorizedAction(
    ROLE_ROUTE.split("/")[ROLE_ROUTE.split("/").length - 1],
    API_ROLE_PREFIX
  );
  const [visible, setVisible] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const { handleGoHistory } = masterService.useMasterAction(ROLE_ROUTE);

  const handleCancel = React.useCallback(() => {
    setVisible(false);
  }, []);
  const url = document.URL;
  // const TabPane = TabsAntd.TabPane;

  const isLinkAssginAppUser = React.useMemo(() => {
    let isCheck: boolean = false;
    if (url.includes("assign-app-user")) {
      isCheck = true;
    }
    return isCheck;
  }, [url]);

  const { model, dispatch } = detailService.useModel<Role>(Role);

  const { isDetail } = detailService.useGetIsDetail<Role>(
    roleRepository.get,
    dispatch
  );

  const { listMapping: listFieldEntity } =
    webService.useConvertMappingData(
      model.roleFieldEntityMappings,
      "fieldEntity"
    );

  const {
    handleChangeAllField,
    handleChangeSingleField,
    handleChangeSelectField,
    handleChangeMappingField,
  } = fieldService.useField(model, dispatch);

  const handleChangeStatus = React.useCallback(
    (checked) => {
      const newModel = { ...model };
      if (checked) {
        newModel.statusId = 1;
      } else {
        newModel.statusId = 0;
      }
      handleChangeAllField(newModel);
    },
    [handleChangeAllField, model]
  );

  const handleChangeIsTendering = React.useCallback(
    (checked) => {
      const newModel = { ...model };
      newModel.isTendering = checked;
      handleChangeAllField(newModel);
    },
    [handleChangeAllField, model]
  );

  // const [routeTypeNew] = useState({
  //   id: 0,
  //   code: null,
  //   name: "Vai trò thường",
  //   color: null,
  //   informations: null,
  //   warnings: null,
  //   errors: null,
  //   disabled: null,
  //   generalInformations: [],
  //   generalWarnings: [],
  //   generalErrors: [],
  // });

  const { handleGoMaster } = detailService.useActionsDetail<Role>(
    model,
    roleRepository.save,
    handleChangeAllField,
    ROLE_ROUTE
  );

  const { notifyUpdateItemSuccess, notifyUpdateItemError } =
    appMessageService.useCRUDMessage();

  const handleSaveRole = React.useCallback(() => {
    setIsLoading(true);
    roleRepository
      .updatePermissionTree(model?.id ? model?.permissions : [])
      .subscribe(
        (res) => {
          roleRepository.save(model).subscribe(
            (res) => {
              notifyUpdateItemSuccess();
              handleChangeAllField(res);
              if (!isDetail) {
                window.location.href = `${ROLE_DETAIL_ROUTE}?id=${res.id}`;
              }
              setIsLoading(false);
            },
            (error) => {
              if (error.response && error.response.status === 400) {
                handleChangeAllField(error.response?.data);
                notifyUpdateItemError();
              }
              setIsLoading(false);
            }
          );
        },
        (error) => {
          if (error.response && error.response.status === 400) {
            notifyUpdateItemError({ message: "Cập nhật quyền thất bại" });
          }
          setIsLoading(false);
        }
      );
  }, [
    handleChangeAllField,
    isDetail,
    model,
    notifyUpdateItemError,
    notifyUpdateItemSuccess,
  ]);

  const handleAssignAppUser = React.useCallback(
    (model) => {
      setIsLoading(true);
      roleRepository.assignAppUser(model).subscribe(
        (item: Role) => {
          notifyUpdateItemSuccess();
          handleGoMaster();
          setIsLoading(false);
        },
        (err) => {
          notifyUpdateItemError();
          setIsLoading(false);
        }
      );
    },
    [handleGoMaster, notifyUpdateItemError, notifyUpdateItemSuccess]
  );
  const { list: appUsers, appUserRoleMappingColumns } =
    useAppUserRoleMappingTable(model, handleChangeAllField);

  const {
    open,
    listMapping,
    countMapping,
    appUserFilter,
    rowSelection,
    spinning,
    handleOpenMapping,
    handleSaveMapping,
    handleCancelMapping,
    handleChangeSelectFilter,
    handleChangeInputSearch,
    handleChangeAppUserAllFilter,
    handlePagination,
    handleChangeInputFilter,
  } = useAppUserRoleMappingModalHook(model, handleChangeAllField);

  const handleChangeSite = React.useCallback(
    (id: number, value: any) => {
      if (value?.code === "/construction/") {
        dispatch({
          type: ModelActionEnum.UPDATE,
          payload: {
            roleType: {
              id: 2,
              code: "Speacial",
              name: "Vai trò đặc thù",
              color: null,
              informations: null,
              warnings: null,
              errors: null,
              disabled: null,
              generalInformations: [],
              generalWarnings: [],
              generalErrors: [],
            },
            roleTypeId: 2,
            site: value,
            siteId: value?.id,
          },
        });
      } else if (value?.code !== "/investment/") {
        dispatch({
          type: ModelActionEnum.UPDATE,
          payload: {
            roleType: {
              id: 1,
              code: "Normal",
              name: "Vai trò thường",
              color: null,
              informations: null,
              warnings: null,
              errors: null,
              disabled: null,
              generalInformations: [],
              generalWarnings: [],
              generalErrors: [],
            },
            roleTypeId: 1,
            site: value,
            siteId: value?.id,
          },
        });
      } else {
        dispatch({
          type: ModelActionEnum.UPDATE,
          payload: {
            site: value,
            siteId: value?.id,
          },
        });
      }
    },
    [dispatch]
  );

  return (
    <Spin spinning={isLoading}>
      <div className="page-content page-content-dxg" id="page-content-dxg-id">
        <div className="info-component ml-4 mb-3">
          <span>{translate("roles.master.header")}</span>
          <span> &gt; </span>
          <span className="info-primary">
            {translate("roles.master.subHeader")}
          </span>
        </div>

        <div className="page page-detail p-t--lg p-l--xxl p-r--xxl p-b--lg">
          <div className="mb-0 d-flex justify-content-between background-w-dxg border-tl-8-dxg">
            <h5 className="font-bold page-title">
              {translate("roles.master.subHeader")}
            </h5>
            <div className="mr-3">
              <Button
                type="secondary"
                className="btn--lg btn-red"
                icon={<Close16 />}
                onClick={handleGoMaster}
              >
                {translate("general.actions.close")}
              </Button>

              <Button
                type="secondary"
                className="btn--lg btn-orange-export ml-3"
                icon={<Time16 />}
                onClick={handleGoHistory(model?.id)}
              >
                {translate("general.actions.viewHistory")}
              </Button>

              {isLinkAssginAppUser
                ? validAction("assignAppUser") && (
                  <Button
                    type="primary"
                    className="btn--lg btn-orange-wIcon ml-3"
                    icon={<Send16 />}
                    onClick={() => handleAssignAppUser(model)}
                  >
                    {translate("general.actions.save")}
                  </Button>
                )
                : ((!isDetail && validAction("create")) ||
                  (isDetail && validAction("update"))) && (
                  <Button
                    type="primary"
                    className="btn--lg btn-orange-wIcon ml-3"
                    icon={<Send16 />}
                    onClick={handleSaveRole}
                  >
                    {translate("general.actions.save")}
                  </Button>
                )}
            </div>
          </div>

          <div className="page-detail__title p-b--sm">
            {!isDetail
              ? translate("general.actions.create")
              : translate("general.detail.title")}
          </div>

          <Row>
            <Col lg={8}>
              <Col lg={24} className="m-b--xxs p-r--sm">
                <FormItem>
                  <InputText
                    label={translate("roles.systemCode")}
                    type={0}
                    value={model.id?.toString()}
                    placeHolder={translate("roles.placeholder.systemCode")}
                    className={"tio-account_square_outlined"}
                    disabled={true}
                  />
                </FormItem>
              </Col>
              <Col lg={24} className="m-b--xxs p-r--sm">
                <FormItem
                  validateStatus={utilService.getValidateStatus(
                    model,
                    nameof(model.code)
                  )}
                  message={model.errors?.code}
                >
                  <InputText
                    isRequired
                    label={translate("roles.code")}
                    type={0}
                    value={model.code}
                    placeHolder={translate("roles.placeholder.code")}
                    className={"tio-account_square_outlined"}
                    onChange={handleChangeSingleField({
                      fieldName: nameof(model.code),
                    })}
                  // disabled={
                  //   (isLinkAssginAppUser && isDetail) ||
                  //   (!isLinkAssginAppUser && isDetail)
                  //     ? true
                  //     : false
                  // }
                  />
                </FormItem>
              </Col>
              <Col lg={24} className="m-b--xxs p-r--sm">
                <FormItem
                  validateStatus={utilService.getValidateStatus(
                    model,
                    nameof(model.name)
                  )}
                  message={model.errors?.name}
                >
                  <InputText
                    isRequired
                    label={translate("roles.name")}
                    type={0}
                    value={model.name}
                    placeHolder={translate("roles.placeholder.name")}
                    className={"tio-account_square_outlined"}
                    onChange={handleChangeSingleField({
                      fieldName: nameof(model.name),
                    })}
                    disabled={isLinkAssginAppUser ? true : false}
                  />
                </FormItem>
              </Col>
              <Col lg={24} className="m-b--xxs p-r--sm">
                <FormItem
                  validateStatus={utilService.getValidateStatus(
                    model,
                    nameof(model.site)
                  )}
                  message={model.errors?.site}
                >
                  <Select
                    isRequired
                    label={translate("roles.site")}
                    type={0}
                    classFilter={SiteFilter}
                    placeHolder={translate("roles.placeholder.site")}
                    getList={roleRepository.singleListSite}
                    onChange={handleChangeSite}
                    value={model.site}
                    disabled={isDetail}
                  />
                </FormItem>
              </Col>
              <Col lg={24} className="m-b--xxs p-r--sm select-no-delete-dxg">
                <FormItem
                  validateStatus={utilService.getValidateStatus(
                    model,
                    nameof(model.roleType)
                  )}
                  message={model.errors?.roleType}
                >
                  <Select
                    isRequired
                    label={translate("roles.role")}
                    type={0}
                    classFilter={SiteFilter}
                    placeHolder={translate("roles.placeholder.role")}
                    getList={roleRepository.singleListRoleType}
                    onChange={(id, value) => {
                      handleChangeSelectField({
                        fieldName: nameof(model.roleType),
                      })(id, value);
                      if (value?.code === "Speacial") {
                        handleChangeMappingField(
                          nameof(model.roleFieldEntityMappings),
                          "fieldEntity"
                        )([]);
                      }
                    }}
                    value={model.roleType}
                    disabled={model?.site?.code !== "/investment/"}
                  />
                </FormItem>
              </Col>

              {model.roleType?.code === "Normal" &&
                <Col lg={24} className="m-b--xxs p-r--sm select-no-delete-dxg">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.roleFieldEntityMappings)
                    )}
                    message={model.errors?.roleFieldEntityMappings}
                  >
                    <MultipleSelect
                      label={translate("roles.fieldEnity")}
                      type={0}
                      classFilter={SiteFilter}
                      placeHolder={translate("roles.placeholder.fieldEnity")}
                      getList={roleRepository.singleListFieldEntity}
                      values={listFieldEntity}
                      onChange={handleChangeMappingField(
                        nameof(model.roleFieldEntityMappings),
                        "fieldEntity"
                      )}
                    />
                  </FormItem>
                </Col>
              }
              <Col lg={24} className="m-b--xxs p-r--sm">
                <FormItem
                  validateStatus={utilService.getValidateStatus(
                    model,
                    nameof(model.status)
                  )}
                  message={model.errors?.status}
                >
                  <div>
                    <div className="label-status">
                      {translate("roles.status")}
                    </div>
                    <Switch
                      checked={model.statusId === 1 ? true : false}
                      onChange={handleChangeStatus}
                      className="switch_status"
                      disabled={isLinkAssginAppUser ? true : false}
                    />
                  </div>
                </FormItem>
              </Col>
              <Col lg={24} className="m-b--xxs p-r--sm">
                <FormItem
                  validateStatus={utilService.getValidateStatus(
                    model,
                    nameof(model.isTendering)
                  )}
                  message={model.errors?.isTendering}
                >
                  <div>
                    <div className="label-status">
                      {translate("roles.isTendering")}
                    </div>
                    <Switch
                      checked={model.isTendering === true ? true : false}
                      onChange={handleChangeIsTendering}
                      className="switch_status"
                      disabled={isLinkAssginAppUser ? true : false}
                    />
                  </div>
                </FormItem>
              </Col>
            </Col>
            <Col lg={1}></Col>

            <Col lg={13} className="permission-tree-view">
              <h5 className="page-detail__title p-b--sm p-t--sm p-l--sm">
                Danh sách quyền
              </h5>
              <PermissionRoleTreeView
                role={model}
                siteId={model.siteId}
                handleChangeAllField={handleChangeAllField}
              />
            </Col>
          </Row>

          {isLinkAssginAppUser ? (
            <>
              <div className="page-detail__title p-t--md">
                {translate("roles.assignAppUserList")}
              </div>
              {isDetail && (
                <div className="permission-role-detai_content_table">
                  <div className="page page-master m-b--lg m-t--sm">
                    <div className="page-master__content">
                      <div className="page-master__tag-filter">
                        <TagFilter
                          value={appUserFilter}
                          translate={translate}
                          keyTranslate={"roles"}
                          handleChangeFilter={handleChangeAppUserAllFilter}
                          onClear={(value: any) => {
                            return 0;
                          }}
                        />
                      </div>
                      <div className="page-master__filter-wrapper d-flex align-items-center justify-content-between">
                        <div className="page-master__filter d-flex align-items-center justify-content-start">
                          <div className="page-master__filter-action-search d-flex align-items-center"></div>
                        </div>

                        <div className="page-master__actions  d-flex align-items-center justify-content-start">
                          <div className="page-master__filter-action d-flex align-items-center">
                            <Button
                              type="primary"
                              className="btn--lg btn-blue"
                              icon={<Add16 />}
                              onClick={handleOpenMapping}
                            >
                              {translate("roles.buttons.addAppUser")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="page-master__content-table">
                      <StandardTable
                        rowKey={nameof(appUsers[0].id)}
                        columns={appUserRoleMappingColumns}
                        dataSource={appUsers}
                        isDragable={true}
                        tableSize={"md"}
                        scroll={{ x: 1000 }}
                      />

                      {visible && (
                        <AppUserRoleAdvanceFilter
                          visible={visible}
                          handleClose={handleCancel}
                          visibleFooter={true}
                          loading={false}
                          size={"sm"}
                          filter={appUserFilter}
                          setVisible={setVisible}
                          handleChangeAllFilter={handleChangeAppUserAllFilter}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <Tabs type="line" className="tab-dxg">
                {/* {isDetail && (
                  <TabPane tab={translate("roles.general.permission")} key="1">
                    <PermissionRoleTreeView
                      role={model}
                      siteId={model.siteId}
                      handleChangeAllField={handleChangeAllField}
                    />
                  </TabPane>
                )} */}

                {/* {isDetail && (
                  <TabPane tab={translate("roles.general.permission")} key="2">
                    <PermissionRoleDetail role={model} siteId={model.siteId} />
                  </TabPane>
                )} */}

                {model?.siteId && (
                  <>
                    {/* <TabPane tab="Phân quyền dữ liệu chung" key="2">
                      <PermissionGeneralField
                        model={model}
                        dispatchModel={dispatch}
                      />
                    </TabPane> */}
                    {/* <TabPane tab="Phân quyền thao tác chung" key="3">
                      <PermissionGeneralActionType
                        model={model}
                        dispatchModel={dispatch}
                      />
                    </TabPane> */}
                  </>
                )}
              </Tabs>
            </>
          )}
        </div>
      </div>
      {open && (
        <AppUserRoleMappingModal
          visible={open}
          handleSave={handleSaveMapping}
          handleClose={handleCancelMapping}
          translate={translate}
          appUserFilter={appUserFilter}
          handleSelectFilter={handleChangeSelectFilter}
          handleChangeInputSearch={handleChangeInputSearch}
          listAppUser={listMapping}
          countAppUser={countMapping}
          loadList={spinning}
          handlePagination={handlePagination}
          rowSelection={rowSelection}
          handleChangeInputFilter={handleChangeInputFilter}
          handleChangeAllFilter={handleChangeAppUserAllFilter}
        // handleChangeSelectFilter={handleChangeSelectFilter}
        />
      )}
    </Spin>
  );
}

export default RoleDetail;
